import { useLazyQuery } from '@apollo/client';

import { Arrayable } from '../../../helper/array';
import { toOrderByInput } from '../../../helper/sort';
import SortBy from '../../../models/SortBy';
import Notification, { NotificationFilterInput, NotificationOrderByInput } from '../models/Notification';
import { GET_NOTIFICATIONS } from './query';

interface QueryData {
  notifications: Notification[];
}

interface QueryVars {
  orderBy?: Arrayable<NotificationOrderByInput>;
  where: Pick<NotificationFilterInput, 'group'>;
}

/**
 * Fetch all the notifications
 */
function useFetchNotifications() {
  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVars>(GET_NOTIFICATIONS, {
    notifyOnNetworkStatusChange: true,
  });

  const fetchNotifications = async (groups: string[], sortBy?: SortBy) => {
    const variables: QueryVars = {
      orderBy: toOrderByInput(sortBy),
      where: {
        group: { _in: groups },
      },
    };

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return response.data?.notifications || [];
  };

  return { fetchNotifications, loading, error, notifications: data?.notifications || [] };
}

export default useFetchNotifications;
